module.exports = __webpack_public_path__ + "img/29ec0329b0ad2e8b962411ad9704293c.png";